export * from './constants/services-available-carousel.constants';

export function rsFrontendDomain(): string {
  return 'rs-frontend-domain';
}
